import { render, staticRenderFns } from "./RenderComponent.vue?vue&type=template&id=f05aa80c&"
import script from "./RenderComponent.vue?vue&type=script&lang=js&"
export * from "./RenderComponent.vue?vue&type=script&lang=js&"
import style0 from "./RenderComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports